import React from 'react';
import './ServicesSummary.css';
import { CheckCircle } from '@phosphor-icons/react';

const services = [
  "Custom Web App Development",
  "Enterprise Web Portals",
  "Frontend & Backend Development",
  "API Development & Integration"
];

const ServicesSummary = () => {
  return (
    <section className="services-summary">
      <div className="summary-container">
        <div className="summary-image-side">
           {/* Here we use a generic placeholder or the LinkedIn image. Based on the picture, it's a large abstract design. */}
           <img 
              src="https://media.licdn.com/dms/image/v2/D560BAQHyFdMA9JTQIA/company-logo_400_400/company-logo_400_400/0/1681048728297?e=2147483647&v=beta&t=2QJ0apb54mzLhJVUf00OSt9-xUKS1ppQYYT6vTgx6Q4" 
              alt="What We Are Illustration" 
              className="summary-large-img" 
            />
        </div>
        <div className="summary-content">
          <h2 className="summary-title">What We Are</h2>
          <p className="summary-text">
            We deliver tailored web application solutions that blend elegant 
            front-end interfaces with robust backend systems.
          </p>
          
          <ul className="service-list">
            {services.map((service, index) => (
              <li key={index} className="service-item">
                <CheckCircle size={24} weight="fill" color="#f8fafc" />
                <span>{service}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="integrations-container" id="industries">
        <div className="integrations-header">
           <h2 className="integrations-title">Industries We Serve</h2>
        </div>
        <div className="projects-grid" style={{
           display: 'grid', 
           gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', 
           gap: '2.5rem', 
           marginTop: '3.5rem'
        }}>
           {/* E-Commerce */}
           <div className="project-card" style={{ display: 'flex', flexDirection: 'column', gap: '1rem', cursor: 'pointer' }}>
             <img src="https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?auto=format&fit=crop&q=80&w=800" alt="E-Commerce App" style={{ width: '100%', height: '220px', objectFit: 'cover', borderRadius: '16px', transition: 'transform 0.3s ease' }} />
             <h3 style={{ color: 'white', margin: 0, fontSize: '1.2rem', fontWeight: '500' }}>Retail & E-Commerce</h3>
             <p style={{ color: '#94a3b8', margin: 0, fontSize: '0.95rem' }}>Next-gen shopping platforms with seamless checkout flows.</p>
           </div>
           
           {/* Healthcare */}
           <div className="project-card" style={{ display: 'flex', flexDirection: 'column', gap: '1rem', cursor: 'pointer' }}>
             <img src="https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?auto=format&fit=crop&q=80&w=800" alt="Healthcare Portal" style={{ width: '100%', height: '220px', objectFit: 'cover', borderRadius: '16px', transition: 'transform 0.3s ease' }} />
             <h3 style={{ color: 'white', margin: 0, fontSize: '1.2rem', fontWeight: '500' }}>Healthcare</h3>
             <p style={{ color: '#94a3b8', margin: 0, fontSize: '0.95rem' }}>Secure patient portals and telemedicine web applications.</p>
           </div>
           
           {/* FinTech */}
           <div className="project-card" style={{ display: 'flex', flexDirection: 'column', gap: '1rem', cursor: 'pointer' }}>
             <img src="https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&q=80&w=800" alt="FinTech Dashboard" style={{ width: '100%', height: '220px', objectFit: 'cover', borderRadius: '16px', transition: 'transform 0.3s ease' }} />
             <h3 style={{ color: 'white', margin: 0, fontSize: '1.2rem', fontWeight: '500' }}>Banking & FinTech</h3>
             <p style={{ color: '#94a3b8', margin: 0, fontSize: '0.95rem' }}>Data-heavy financial dashboards and banking portals.</p>
           </div>

           {/* Education */}
           <div className="project-card" style={{ display: 'flex', flexDirection: 'column', gap: '1rem', cursor: 'pointer' }}>
             <img src="https://images.unsplash.com/photo-1501504905252-473c47e087f8?auto=format&fit=crop&q=80&w=800" alt="EdTech Platform" style={{ width: '100%', height: '220px', objectFit: 'cover', borderRadius: '16px', transition: 'transform 0.3s ease' }} />
             <h3 style={{ color: 'white', margin: 0, fontSize: '1.2rem', fontWeight: '500' }}>Education & EdTech</h3>
             <p style={{ color: '#94a3b8', margin: 0, fontSize: '0.95rem' }}>Interactive learning management systems (LMS).</p>
           </div>

           {/* Real Estate */}
           <div className="project-card" style={{ display: 'flex', flexDirection: 'column', gap: '1rem', cursor: 'pointer' }}>
             <img src="https://images.unsplash.com/photo-1560518883-ce09059eeffa?auto=format&fit=crop&q=80&w=800" alt="Real Estate App" style={{ width: '100%', height: '220px', objectFit: 'cover', borderRadius: '16px', transition: 'transform 0.3s ease' }} />
             <h3 style={{ color: 'white', margin: 0, fontSize: '1.2rem', fontWeight: '500' }}>Real Estate</h3>
             <p style={{ color: '#94a3b8', margin: 0, fontSize: '0.95rem' }}>Property listing directories with interactive maps.</p>
           </div>
           
           {/* Logistics */}
           <div className="project-card" style={{ display: 'flex', flexDirection: 'column', gap: '1rem', cursor: 'pointer' }}>
             <img src="https://images.unsplash.com/photo-1494412574643-ff11b0a5c1c3?auto=format&fit=crop&q=80&w=800" alt="Logistics Software" style={{ width: '100%', height: '220px', objectFit: 'cover', borderRadius: '16px', transition: 'transform 0.3s ease' }} />
             <h3 style={{ color: 'white', margin: 0, fontSize: '1.2rem', fontWeight: '500' }}>Logistics & Supply</h3>
             <p style={{ color: '#94a3b8', margin: 0, fontSize: '0.95rem' }}>Complex shipment tracking and inventory management.</p>
           </div>

           {/* Entertainment */}
           {/* (Removed per request) */}

           {/* SaaS */}
           {/* (Removed per request) */}
        </div>
      </div>
    </section>
  );
};

export default ServicesSummary;
